import { BooleanDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/BooleanDataDefinition";
import { IfThenExpression } from "../../../rule-engine-core/Expressions/Expressions/Logic/IfThenExpression";

import { getTestInputDataDefinition } from "../DataDefinition";
import { StringIsNotEmptyExpression } from "../../../rule-engine-core/Expressions/Expressions/String/StringIsNotEmptyExpression";
import { ExpressionConfiguration } from "../../../rule-engine-core/Expressions/ExpressionConfiguration";
import { StringIsValidEmailExpression } from "../../../rule-engine-core/Expressions/Expressions/String/StringIsValidEmailExpression";
import { ExistsExpression } from "../../../rule-engine-core/Expressions/Expressions/Logic/Exists";
import { IsTrueExpression } from "../../../rule-engine-core/Expressions/Expressions/Logic/IsTrue";
import { IsFalseExpression } from "../../../rule-engine-core/Expressions/Expressions/Logic/IsFalse";
import { StatementRuleConfiguration } from "../../../rule-engine-core/Rule/Statement/StatementRuleConfiguration";

export const getStatementRuleEmpty = (): StatementRuleConfiguration => {
    const rule = new StatementRuleConfiguration();

    rule.inputData = getTestInputDataDefinition();
    return rule;
};

export const getStatementRuleExample = (): StatementRuleConfiguration => {
    const rule = new StatementRuleConfiguration();

    let exp1 = new ExpressionConfiguration();

    let baseExpression = new IfThenExpression();

    let textNotEmpty = new StringIsNotEmptyExpression();
    textNotEmpty.value1.variableName = "emergencyContactName";
    baseExpression.ifBranches[0]!.ifExpression!.elements[0]!.subExpression = textNotEmpty;

    baseExpression.ifBranches[0]!.ifExpression!.add();
    textNotEmpty = new StringIsNotEmptyExpression();
    baseExpression.ifBranches[0]!.ifExpression!.elements[1]!.subExpression = textNotEmpty;
    textNotEmpty.value1.variableName = "emergencyContactPhoneNumber";

    baseExpression.ifBranches[0]!.ifExpression!.add();
    textNotEmpty = new StringIsNotEmptyExpression();
    baseExpression.ifBranches[0]!.ifExpression!.elements[2]!.subExpression = textNotEmpty;
    textNotEmpty.value1.variableName = "emergencyContactRelationship";

    baseExpression.ifBranches[0]!.ifExpression!.add();
    let exp = new StringIsValidEmailExpression();
    exp.value1.variableName = "emailAddress";
    baseExpression.ifBranches[0]!.ifExpression!.elements[3]!.subExpression = exp;

    baseExpression.ifBranches[0]!.ifExpression!.add();
    let exists = new ExistsExpression();
    exists.dataPath = "dateOfHire";
    baseExpression.ifBranches[0]!.ifExpression!.elements[4]!.subExpression = exists;

    baseExpression.ifBranches[0]!.ifExpression!.add();
    let isTrue = new IsTrueExpression();
    isTrue.value1.variableName = "fullTime";
    baseExpression.ifBranches[0]!.ifExpression!.elements[5]!.subExpression = isTrue;

    let second = baseExpression.addIfBranch();

    exp = new StringIsValidEmailExpression();
    exp.value1.variableName = "emailAddress";

    second.ifExpression.elements[0]!.subExpression = exp;

    second.ifExpression!.add();
    exists = new ExistsExpression();
    exists.dataPath = "dateOfHire";
    second.ifExpression!.elements[1]!.subExpression = exists;

    second.ifExpression!.add();
    let isFalse = new IsFalseExpression();
    isFalse.value1.variableName = "fullTime";
    second.ifExpression!.elements[2]!.subExpression = isFalse;

    isTrue = new IsTrueExpression();
    isTrue.value1.variableName = "onboarded";

    baseExpression.defaultOutput.subExpression = isTrue;

    isFalse = new IsFalseExpression();
    isFalse.value1.variableName = "onboarded";
    baseExpression.trueOutput.subExpression = isFalse;
    exp1.expression = baseExpression;

    rule.inputData = getTestInputDataDefinition();
    exp1.inputData = getTestInputDataDefinition();
    rule.expression = exp1;

    rule.executionResult = new BooleanDataDefinition();

    return rule;
};
